<template>
  <section>
    <el-form-item label="所属公司">
      <el-select :disabled="noSelectOrganization" size="small" @change="getMeetingRoom()" class="organization-select"
        v-model="form.depId" placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="*会议名称/简介">
      <el-col :span="10">
        <el-input size="small" v-model="form.name"></el-input>
      </el-col>
    </el-form-item>
    <el-form-item label="*会议地点">
      <el-select size="small" v-model="form.roomId" placeholder="请选择会议地点">
        <el-option v-for="item in meetingRoomData" :key="item.id" :label="item.address" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>

    <el-row>
      <el-col :span="10">
        <el-form-item label="*会议时间">
          <el-date-picker style="width:100%!important;" v-model="form.conferenceTime" size="small"
            value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择会议日期时间">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="*预计会议时间">
          <el-input style="width:100px;" size="small" type="number" v-model="form.useTime"></el-input>&nbsp;&nbsp;分钟
        </el-form-item>
      </el-col>
    </el-row>

    <el-form-item label="*会议要求">
      <el-col :span="18">
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入会议要求" v-model="form.req">
        </el-input>
      </el-col>
    </el-form-item>
    <el-form-item label="*参会人员">
      <div class="contact-user-list" v-if="selectArr.length>0" style="margin-right:5px;">
        <div class="user-item" v-for="user,i in selectArr">
          <span class="name">{{user.name}}</span>
          <span @click="deleteUsers(1,i)" class="iconfont icon-close1"></span>
        </div>
      </div>
      <el-button @click="addUsers(1)" style="margin-left:-5px;" icon="el-icon-plus" size="small" type="primary" plain>
        添加参会人员</el-button>
    </el-form-item>

    <div class="clear">
      <el-form-item label="会议资料/附件">
        <attachments style="margin-left:-15px;" :projectId="form.projectId" :contractId="form.contractId"
          ref="attachments" :arr="attachmentArr" :type='995'></attachments>
      </el-form-item>
    </div>

    <el-form-item label="会议准备">
      <el-checkbox v-model="isForm2">是否需要会议准备</el-checkbox>
      <div v-if="isForm2" style="padding:10px;border:1px #ccc solid;border-radius:5px;">
        <div class="clear">
          <el-checkbox v-model="form2.isHaveCamera">摄像</el-checkbox>
          <el-checkbox v-model="form2.isHaveTea">茶水</el-checkbox>
          <el-checkbox v-model="form2.isHaveEat">就餐</el-checkbox>
          <el-checkbox v-model="form2.isHaveProjector">投影</el-checkbox>
        </div>
        <div class="clear">
          <el-checkbox v-model="form2.isHaveSeat">座位牌</el-checkbox>
          <el-input type="textarea" v-if="form2.isHaveSeat" size="mini" placeholder="输入需要座位牌的具体安排、人员"
            v-model="form2.seat"></el-input>
        </div>
        <div class="clear" style="margin-top:10px;">
          <el-input type="textarea" v-model="form2.remark" placeholder="您可以输入更多需要的会议准备"></el-input>
        </div>

        <div class="contact-user-list" style="margin-top:5px;">
          <div class="user-item" v-for="user,i in selectPlanArr">
            <span class="name">{{user.name}}</span>
            <span @click="deleteUsers(2,i)" class="iconfont icon-close1"></span>
          </div>
        </div>
        <el-button size="small" @click="addUsers(2)" type="primary">选择会议准备推送人</el-button>
      </div>
    </el-form-item>
    <el-form-item label="会议通知">
      <el-checkbox v-model="form.isWx">企业微信通知</el-checkbox>
      <el-checkbox v-model="form.isSms">短信通知</el-checkbox>
    </el-form-item>


    <div class="tip" style="margin:20px 0 0 40px">
      * 意见与审批
    </div>
    <div class="clear label-mx">

      <el-form-item label="审批人">
        <user-info style="float:left;width:auto;" v-if="Leader" :userData='Leader'></user-info>
        <span v-else style="color:#999;">该会议室暂未选择管理员</span>
      </el-form-item>
    </div>

    <!-- <el-form-item label="">
            <el-button :loading="formLoading" @click="createMeeting()" class="form-btn" type="success">确认新建会议
            </el-button>
          </el-form-item> -->
    <!-- </el-form>
      </el-col>
    </div>
  </div> -->

  </section>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Attachments from '@/components/Attachments'
  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      Attachments,
      UserInfo
    },
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        createMeetingData: state => state.meeting.createMeetingData,
        contactSelectArr: state => state.main.contactSelectArr,
        contactApprovalItem: state => state.main.contactApprovalItem,
      })
    },
    props: ['formByFather', 'userData', 'formByFather2', 'selectArrByFather', 'selectPlanArrByFather',
      'isForm2ByFather'
    ],
    data() {
      return {
        organizationListData: [],
        noSelectOrganization: false,
        meetingRoomData: [],
        form: {},
        isForm2: false,
        form2: {},

        Leader: '',

        attachmentArr: [],
        // 1: 参会  2：准备
        selectType: '',
        // 参会人员
        selectArr: [],
        // 会议准备人员
        selectPlanArr: [],

        formLoading: false,
      }
    },
    created() {},
    mounted() {
      this.form = this.formByFather
      this.form2 = this.formByFather2
      this.selectArr = this.selectArrByFather
      this.selectPlanArr = this.selectPlanArrByFather
      this.isForm2 = this.isForm2ByFather
      this.attachmentArr = this.form.attachments

      this.getMeetingRoom()

      this.organizationListData = this.organization[0].childDepts
      // if (this.userData.secDepIds.split(",")[0] == "7") {
      //   this.noSelectOrganization = false
      // }

    },
    methods: {
      // nowSelectRoom(row) {
      //   console.log(row)
      // },
      deleteUsers(type, index) {
        if (type == 1) {
          this.selectArr.splice(index, 1)
        } else {
          this.selectPlanArr.splice(index, 1)
        }
      },
      // 添加参会人员
      addUsers(type) {
        this.selectType = type

        let _sr = []
        switch (type) {
          case 1:
            _sr = this.selectArr
            break;
          case 2:
            _sr = this.selectPlanArr
            break;
        }
        this.$store.commit('set_contactSelectArr', _sr)
        this.$store.commit('set_contactApprovalItem', false)

        this.$store.commit('set_contactShow', true)
        if (this.selectType == 1) {
          this.$store.commit('set_contactSingleSelect', false)
        } else {
          this.$store.commit('set_contactSingleSelect', true)
        }
      },
      getMeetingRoom() {
        // this.form.roomId = ""
        ajax.post('/conference/room/list', {
          'depId': this.form.depId
        }, (res) => {
          this.meetingRoomData = res.vo.array
        })
      },

      getSelectPlanArr() {
        return this.selectPlanArr
      },
      getFromData() {
        // this.form.approvalUserIds = this.$refs.approval.getUserIds()
        this.form.approvalUserIds = this.Leader.id
        this.form.attachments = this.$refs.attachments.getAttachments()
        this.form.userIds = this.selectArr.map(item => item.id).join()
        return this.form
      },
      getFrom2Data() {
        return this.form2
      },
      getIsFrom2() {
        return this.isForm2
      },

      getAdminByRoomId() {
        if (!this.meetingRoomData) {
          return
        }
        let room = this.meetingRoomData.find((x) => {
          return x.id == this.form.roomId
        })
        if (room) {
          this.Leader = room.admin
        }
      },
    },
    watch: {
      contactSelectArr() {
        // 非审批人员选择器，才进入Form表单人员选择器
        if (!this.contactApprovalItem) {
          if (this.selectType == 1) {
            this.selectArr = this.contactSelectArr
          }
          if (this.selectType == 2) {
            this.selectPlanArr = this.contactSelectArr
          }
        }
      },
      formByFather() {
        this.form = this.formByFather
        // this.attachmentArr = this.form.attachments
      },
      formByFather2() {
        this.form2 = this.formByFather2
      },
      selectArrByFather() {
        this.selectArr = this.selectArrByFather
      },
      selectPlanArrByFather() {
        this.selectPlanArr = this.selectPlanArrByFather
      },
      isForm2ByFather() {
        this.isForm2 = this.isForm2ByFather
      },


      meetingRoomData() {
        this.getAdminByRoomId()
      },
      'form.roomId'() {
        this.getAdminByRoomId()
      },
      'form.attachments'() {
        this.attachmentArr = this.form.attachments
      }

    },
    // beforeRouteLeave(to, from, next) {
    //   next()
    // },
  };

</script>



// WEBPACK FOOTER //
// src/page/meeting/createForm.vue